export default "__VITE_ASSET__DS47PP9M__"